import { StandardInput } from '../../../components/forms';
import { ComponentType, ReactNode } from 'react';
import { ResourceEntity, ZoneEntity } from '../../../types/game-document/';
import {
  Checkbox,
  CheckboxChangeEvent,
  InputChangeEvent
} from '@progress/kendo-react-inputs';
import { EditorMode } from '../../../types/editor-mode';
import { RequiredInput } from './zone-editor-window';

interface ZoneEditorProps {
  editorMode: EditorMode;
  entity: ZoneEntity;
  resources: ResourceEntity[];
  handleInputChange: (event: InputChangeEvent | CheckboxChangeEvent) => void;
  children?: ReactNode | undefined;
  requiredInputs?: RequiredInput[];
  displayZoneTitleSetting?: boolean;
}

export const ZoneEditor: ComponentType<ZoneEditorProps> = ({
  editorMode,
  entity,
  resources,
  requiredInputs,
  handleInputChange,
  displayZoneTitleSetting,
  ...props
}: ZoneEditorProps) => {
  return (
    <>
      <div className={`row mt-2 ${displayZoneTitleSetting ? '' : 'ml-0'}`}>
        <div
          className={`${displayZoneTitleSetting ? 'col-6' : 'col-12 p-0 m-0'}`}>
          <StandardInput
            name={'titleResId'}
            label={'Title'}
            value={
              resources.find((resource) => resource.id === entity?.titleResId)
                ?.value ?? ''
            }
            onChange={handleInputChange}
            validationMessage={
              requiredInputs?.find((item) => item.name === 'titleResId')
                ?.errorMessage
            }
          />
        </div>
        {displayZoneTitleSetting && (
          <div className={'col-6 d-flex align-items-end pb-2'}>
            <Checkbox
              size={'large'}
              label={'Show zone map title on map'}
              name={'isTitleVisible'}
              value={entity.isTitleVisible}
              onChange={handleInputChange}
            />
          </div>
        )}
      </div>
      <StandardInput
        name={'description'}
        label={'Description'}
        value={entity?.description}
        onChange={handleInputChange}
      />
      {editorMode === 'full' && (
        <Checkbox
          name={'isVisible'}
          size={'large'}
          value={entity.isVisible}
          onChange={handleInputChange}
          label={'Visible'}
        />
      )}
      {props.children}
    </>
  );
};
